<template>
  <div class="massction-host-modal">
    <div class="modal-header-group">
      <p class="title-text mb-3">
        {{ modalTitle }}
      </p>
      <svg
        class="close-btn"
        @click="$bvModal.hide('host')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>

    <p class="host-text-header">{{ $t("addExpectedVisitor.selectTheHost") }}</p>
    <div class="d-flex vp-mb-24">
      <vpMultiselect
        class="massaction-host-input"
        :options="hostOptions"
        v-model="hostModel.selectedHost.name"
        :label="userSearchLabel"
        trackBy="user_id"
        :placeholder="$t('addExpectedVisitor.searchByNamePhoneNumberEmail')"
        :show-labels="false"
        :multiple="false"
        :isLoading="isLoading"
        @searchChange="findHost"
        :disabled="!hostModel.select_host_permitted"
        dropDownStyle="relative"
      />
    </div>

    <span
      v-if="hostModel.allow_no_host_select && !hostModel.select_host_permitted"
      class="host-note-no-users-available"
      ><b>{{ $t("common.notes.note") }}:</b>
      {{
        $t("addExpectedVisitor.noUsersAvailableSelectedAsHostCheckbox")
      }}</span
    >
    <!-- <div class="host-error-no-users-available">
      <span >No users available to be selected as a host and you will not be able to sign the user in.</span>
    </div> -->

    <b-form-checkbox
      v-if="hostModel.allow_no_host_select"
      v-model="hostModel.no_host_selected"
      class="host-checkbox"
    >
      <span v-text="hostModel.hostMessage"></span>
    </b-form-checkbox>

    <button
      class="fillin-btn vp-font-weight-700"
      @click="onSubmit"
      :disabled="
        (hostModel.isDirty && !modelTouched) ||
        (!hostModel.selectedHost.name &&
          !hostModel.no_host_selected &&
          hostModel.allow_no_host_select) ||
        (!hostModel.selectedHost.name && !hostModel.allow_no_host_select)
      "
    >
      {{ buttonValue }}
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { debounce, toUpper } from "lodash";

export default {
  data() {
    return {
      modelTouched: false,
      hideIcon: false,
      hostOptions: [],
      hostModel: {},
      userSearchLabel: "userName_with_userType",
      findHost: "",
      regEmail:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      modalTitle: "",
      isLoading: false,
    };
  },
  watch: {
    "hostModel.selectedHost.name": {
      handler(selectedHost, previousHostValue) {
        if (previousHostValue) this.modelTouched = true;
        if (selectedHost) {
          this.hostModel.no_host_selected = false;
          this.hostModel.selectedHost.id = selectedHost.user_id;
        }
      },
    },
    "hostModel.no_host_selected": {
      handler(currentValue, previousValue) {
        if (currentValue) {
          this.hostModel.selectedHost.name = null;
          this.hostModel.selectedHost.id = null;
        }
        if (previousValue && this.hostModel.allow_no_host_select)
          this.modelTouched = true;
      },
    },
  },
  methods: {
    ...mapActions("visit", ["hostsBySearch"]),
    async findHostName(val) {
      this.isLoading = true;
      try {
        this.hostOptions = [];
        this.userSearchLabel = "userName_with_userType";
        if (val.length) {
          const params = {
            journey_flow_id: this.hostModel.journey_flow_id,
            search: val,
            //   user_ids: this.hostModel.user_ids,
            //   user_id: this.hostModel.user_id,
            [this.hostModel.host_user_ids ? "user_ids" : "user_id"]:
              this.hostModel.host_user_ids || this.hostModel.user_id,
            site_id: this.hostModel.site_id,
            user_type_id: this.hostModel.user_type_id,
          };

          await this.hostsBySearch(params).then((data) => {
            this.hostOptions = data.data;
          });
          let checkStringIsEmail = this.validateEmail(val);
          if (checkStringIsEmail) {
            this.userSearchLabel = "email";
          } else if (!isNaN(val)) {
            this.userSearchLabel = "phone";
          } else {
            this.userSearchLabel = "userName_with_userType";
          }
        }
      } catch (e) {
        console.error("Could not fetch host list ", e);
      } finally {
        this.isLoading = false;
      }
    },
    validateEmail(email) {
      let isEmailForm = false;
      if (this.regEmail.test(email)) {
        isEmailForm = true;
      }
      return isEmailForm;
    },
    onSubmit() {
      this.hostModel.isDirty = true;
      if (this.hostModel.allAction)
        this.$emit(
          "massActionHostSubmt",
          Object.assign(this.hostModel, { allAction: false })
        );
      else this.$emit("hostSubmit", this.hostModel);
      this.$bvModal.hide("host");
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("visit", ["getHostsBySearch"]),
    buttonValue() {
      return this.hostModel.isDirty && !this.hostModel.allAction
        ? toUpper(this.$t("common.update"))
        : toUpper(this.$t("common.add"));
    },
  },
  beforeMount() {
    this.hostModel = JSON.parse(JSON.stringify(this.getModalInfo));
    if (
      this.hostModel.area &&
      this.hostModel.area.login_mode === "signIn_signOut"
    ) {
      this.hostModel.hostMessage = this.$tc("signInOut.hostMsg", 1);
    } else if (
      this.hostModel.area &&
      this.hostModel.area.login_mode === "checkIn_only"
    ) {
      this.hostModel.hostMessage = this.$tc("signInOut.hostMsg", 2);
    }

    this.modalTitle =
      this.hostModel.selectedHost.id || this.hostModel.no_host_selected
        ? this.$tc("signInOut.hostStatus", 2)
        : this.$tc("signInOut.hostStatus", 1);
  },
  created() {
    this.findHost = debounce(this.findHostName.bind(this), 500);
  },
};
</script>

<style lang="scss">
.massction-host-modal {
  .host-text-header {
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: 400;
    color: #787878;
  }
  .fillin-btn {
    background: #103f5e;
    height: 44px;
    width: 416px;
    border-radius: 22px;
    border: 0;
    color: #fff;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 17px;
  }
  .fillin-btn:disabled {
    background-color: #96abb8;
  }
  .modal-header-group {
    display: flex;
    justify-content: space-between;
    width: 250px;
    margin-top: 15px;
    margin-inline-end: auto;
    margin-bottom: 30px;
    margin-inline-start: 158px;
    .title-text {
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      text-align: center;
      color: #000000;
    }
    .title-text:lang(ar) {
      transform:translateX(6px)  !important;
    }
  }
}
.host-checkbox {
  width: fit-content;
  margin: auto;
  padding-inline-start: 0;

  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #666666;
  display: flex;
  justify-content: space-between;
  span {
    position: relative;
    top: -1px;
    inset-inline-end: -10px;
  }
}
.host-note-no-users-available {
  margin-top: 8px;
  margin-inline-start: 54px;
  color: var(--939393, #939393);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.25px;
}

.host-error-no-users-available {
  width: 376px !important;
  margin-inline-start: 58px;
  margin-top: 8px;
  color: var(--f-46-a-6-a, #f46a6a);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0.25px;
}

.is-invalid {
  border: 1.5px solid #f46a6a !important;
  border-radius: 4px;
}
</style>
